export const PERSISTED_AT_SET_VALUE = 'atRetirement/setValue/persistedAt';

export const setPersistedAtValue = () => ({ type: PERSISTED_AT_SET_VALUE });
